import { useState, useEffect } from 'react';
import { fetchGoals, saveGoals } from './api';
import { isLoggedIn } from './auth';

export function useGoals() {
  const [goals, setGoals] = useState({
    dailyCalories: 2000,
    dailyProtein:  150,
    dailyCarbs:    200,
    dailyFat:      65,
    dailyWaterMl:  2500,  
  });

  useEffect(() => {
    // Only fetch goals if user is logged in
    // Prevents 401 loop on initial load
    if (!isLoggedIn()) return;
    fetchGoals().then(setGoals).catch(err => {
      // Silently ignore 401 — interceptor handles it
      if (err.response?.status !== 401) console.error(err);
    });
  }, []);

  async function updateGoals(newGoals) {
    await saveGoals(newGoals);
    setGoals(newGoals);
  }

  return { goals, updateGoals };
}